module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "login",
      "options": _vm.Storage.webFilter,
      "multiple": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": _vm.$t('filter.webmaster_grid'),
      "label": "login",
      "searchable": true,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.dispatchInputAction
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n           " + _vm._s(props.option.login) + "\n          ")])])]
      }
    }]),
    model: {
      value: (_vm.Storage.webSelectedFilter),
      callback: function($$v) {
        _vm.Storage.webSelectedFilter = $$v
      },
      expression: "Storage.webSelectedFilter"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-837c409a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/ByWmFilter.vue
// module id = 585
// module chunks = 0